import { makeStyles } from '@material-ui/core/styles'

import { getDirection, lang } from '../../../../../localization'

export default makeStyles((theme) => ({
  rootGrid: {
    position: 'relative'
  },
  monthsListContainer: {
    flexWrap: 'nowrap',
    position: 'absolute',
    flexDirection: lang === 'fa' ? 'row-reverse' : 'row',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    },
    [theme.breakpoints.between(600, 960)]: {
      flexDirection: 'column',
      position: 'unset'
    }
  },
  datePickerLastMonth: {
    [theme.breakpoints.down('xs')]: {
      marginBottom: 140
    }
  },
  nextMonthButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '1px 6px',
    borderRadius: 6,
    border: '1px solid #bbbbbb',
    transform: `rotate(${getDirection() === 'rtl' ? '180deg' : '0deg'})`,
    [theme.breakpoints.between('sm', 'md')]: {
      right: 10
    }
  },
  prevMonthButton: {
    position: 'absolute',
    top: 0,
    left: 0,
    padding: '1px 6px',
    borderRadius: 6,
    border: '1px solid #bbbbbb',
    transform: `rotate(${getDirection() === 'rtl' ? '180deg' : '0deg'})`,
    [theme.breakpoints.between('sm', 'md')]: {
      left: 10
    }
  },
  nextMonthIcon: {
    color: '#bbbbbb'
  },
  prevMonthIcon: {
    color: '#bbbbbb'
  }
}))
